export * from './component/codemanagement-index/codemanagement-index.component';
export * from './component/languagepack-index/languagepack-index.component';
export * from './component/report-index/report-index.component';

export * from './component/fmiproduct-index/fmiproduct-index.component';
export * from './component/fmiproduct-list/fmiproduct-list.component';

export * from './component/survey-index/survey-index.component';
export * from './component/survey-list/survey-list.component';

export * from './component/pmdocument-index/pmdocument-index.component';
export * from './component/pmdocument-list/pmdocument-list.component';

export * from './component/pmuser-index/pmuser-index.component';
export * from './component/pmuser-list/pmuser-list.component';

export * from './component/partsmanual-index/partsmanual-index.component';
export * from './component/partsmanual-list/partsmanual-list.component';

export * from './administration.routing';
